// extracted by mini-css-extract-plugin
export default {"imageGallery":"ImageGallery_imageGallery__9FAVk","image":"ImageGallery_image__Mxewo","playbtnBg":"ImageGallery_playbtnBg__4lsMF","popup":"ImageGallery_popup__dfadL"};